import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Accordion } from '../../display/Accordion/Accordion.es.js';
import { Heading } from '../../display/Heading/Heading.es.js';
import { HeadingLevel } from '../../display/Heading/HeadingLevel.es.js';
import { Button } from '../../navigation/Button/Button.es.js';

const Styles = labelStyles("FAQ", {
  root: css`
    padding: var(--zds-space-32) var(--zds-space-20);

    @media screen and (min-width: 650px) {
      padding: var(--zds-space-48) var(--zds-space-32);
    }
  `,
  faqContent: css`
    max-width: 1170px;
    margin: 0 auto;
  `,
  heading: css`
    margin-bottom: var(--zds-space-32);
    font: var(--zds-section-header);
    color: var(--zds-text-stronger);
  `,
  ctaContainer: css`
    margin-top: var(--zds-space-32);

    & > a,
    & > button {
      width: 100%;
    }

    @media screen and (min-width: 650px) {
      margin-top: var(--zds-space-32);
      & > a,
      & > button {
        width: auto;
      }
    }
  `,
  grid: css`
    display: grid;
    gap: var(--zds-space-20);

    @media screen and (min-width: 650px) {
      gap: var(--zds-space-16);
    }
  `
});
const FAQ = ({ heading = "Frequently Asked Questions", items, children, ctaText, ctaHref, onCtaClick }) => {
  return jsx(
    "div",
    { css: Styles.root, "data-zds": true },
    jsx(
      "div",
      { css: Styles.faqContent, "data-zds": true },
      jsx(
        HeadingLevel,
        null,
        jsx(Heading, { css: Styles.heading }, heading)
      ),
      items && items.length > 0 ? jsx("div", { css: Styles.grid, "data-zds": true }, items.map((item) => jsx(Accordion, { key: item.title, title: item.title, href: item.href, isInitiallyOpen: item.isInitiallyOpen, isOpen: item.isOpen, onToggle: item.onToggle }, item.content))) : children,
      ctaText && (ctaHref || onCtaClick) && jsx(
        "div",
        { css: Styles.ctaContainer, "data-zds": true },
        jsx(Button, { href: ctaHref, size: "small", onClick: onCtaClick }, ctaText)
      )
    )
  );
};

export { FAQ };
//# sourceMappingURL=FAQ.es.js.map
